// ============================================
// UTILS/DINERO.JS — como se ENSEÑA el dinero (fuente unica de presentacion)
// ============================================
// SIN-REDONDEO (2026-10-12). Regla de Ricardo: "No quiero que el sistema me redondee ni un
// costo en todo el sistema." Los importes se guardan y se calculan con su precision; los
// 2 decimales son SOLO presentacion, y van SIEMPRE: "$3,132.09", nunca "$3,132".
// Antes convivian ~15 formateadores locales a 0 decimales y la misma ficha enseñaba
// "$3,132 MXN" arriba y "$3,132.09" en el campo editable.
//
// Lo vigila `node scripts/portero-redondeo.js`.
//
// Uso:
//   import { fmtDinero, fmtNumDinero, OPC_DINERO } from './utils/dinero';
//   fmtDinero(3132.09)            -> "$3,132.09"
//   fmtDinero(3132.09, 'MXN')     -> "$3,132.09 MXN"
//   fmtNumDinero(3132.09)         -> "3,132.09"   (sin signo, para plantillas propias)
//   n.toLocaleString('es-MX', OPC_DINERO)

export const OPC_DINERO = Object.freeze({ minimumFractionDigits: 2, maximumFractionDigits: 2 });

const NF = new Intl.NumberFormat('es-MX', OPC_DINERO);

export function fmtNumDinero(n) {
  const v = Number(n);
  return NF.format(Number.isFinite(v) ? v : 0);
}

export function fmtDinero(n, sigla) {
  const v = Number(n);
  const s = Number.isFinite(v) && v < 0 ? `-$${fmtNumDinero(-v)}` : `$${fmtNumDinero(v)}`;
  return sigla ? `${s} ${sigla}` : s;
}
